module.exports = __webpack_public_path__ + "img/starscapes.c3e63d46.png";